export type ExitIntentPromoKind = "value" | "percent" | "free-shipping";
export type FreeShippingScope = "orders" | "duration";

export type ExitIntentPromoView = {
  kind: ExitIntentPromoKind;
  amount: number;
  validDays: number;
  freeShippingOrders: number;
  freeShippingScope: FreeShippingScope;
  offerText: string;
};

export const defaultPromoView = (): ExitIntentPromoView => ({
  kind: "free-shipping",
  amount: 10,
  validDays: 90,
  freeShippingOrders: 1,
  freeShippingScope: "duration",
  offerText: "free shipping on every order for 90 days",
});

const daysLabel = (n: number) => `${n} Day${n === 1 ? "" : "s"}`;

export const signupHeadline = (promo: ExitIntentPromoView): string => {
  if (promo.kind === "free-shipping") {
    if (promo.freeShippingScope === "duration") {
      return `Free Shipping for ${daysLabel(promo.validDays)}?`;
    }
    const n = promo.freeShippingOrders;
    return `Free Shipping on Your Next ${n} Order${n === 1 ? "" : "s"}?`;
  }
  if (promo.kind === "percent") {
    return `${promo.amount}% Off Your First Order?`;
  }
  return `$${promo.amount} Off Your First Order?`;
};

export const signupSubhead = (promo: ExitIntentPromoView): string => {
  if (promo.kind === "free-shipping" && promo.freeShippingScope === "duration") {
    return "Sign up and get it on every order.";
  }
  return `Sign up and get ${promo.offerText || "a welcome offer"}.`;
};

export const claimButtonLabel = (promo: ExitIntentPromoView): string => {
  if (promo.kind === "free-shipping") return "Claim My Free Shipping";
  return "Claim My Offer";
};

export const successHeadline = (promo: ExitIntentPromoView): string => {
  if (promo.kind === "free-shipping" && promo.freeShippingScope === "duration") {
    return `Congratulations! You've Got Free Shipping for ${daysLabel(
      promo.validDays,
    )} on All Purchases!`;
  }
  return `Congratulations! You've got ${promo.offerText || "your welcome offer"}.`;
};

export const successSubhead = (promo: ExitIntentPromoView): string => {
  if (promo.kind === "free-shipping" && promo.freeShippingScope === "duration") {
    return `It'll auto-apply at checkout for the next ${promo.validDays} days.`;
  }
  return "It'll auto-apply at checkout.";
};
